const regularizeCurrency = (currency) => {
  const cleanNum = currency.match(/\d+/g)?.join('') || ''
  return `${cleanNum.slice(0, -2)}.${cleanNum.slice(-2)}`
}

export default regularizeCurrency
